// extracted by mini-css-extract-plugin
export default {"container":"Tasks_container__r-dkc"};